import { IApplicationState } from '../../../../../../../types/types';
import { TChatId } from '../../../../../../../types/rest/IRestChat';

export const getOpenedChatId = (state: IApplicationState): TChatId => {
    return state?.chatView?.openedChatId;
}
